<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <!-- Sidebar Content -->
      <div class="sidebar-content" :class="{ show: mqShallShowLeftSidebar }">
        <!-- Sidebar close icon -->
        <span class="sidebar-close-icon">
          <feather-icon
            icon="XIcon"
            size="16"
            @click="$emit('update:mq-shall-show-left-sidebar', false)"
          />
        </span>

        <!-- Header -->
        <div class="chat-fixed-search">
          <div class="d-flex align-items-center w-100">
            <!-- Search -->
            <b-input-group
              v-show="isShowSearch"
              class="input-group-merge ml-0 w-100 round"
            >
              <b-input-group-prepend is-text class="">
                <b-form-select
                  v-model="query.searchType"
                  :options="searchTypeOptions"
                  size="sm"
                  class="border-0 ml-1"
                  @input="onChangeSearchType"
                />
              </b-input-group-prepend>
              <b-form-input
                v-model="query.search"
                v-debounce:500ms="search"
                :placeholder="$t('general.search')"
              />
            </b-input-group>
            <div v-show="!isShowSearch" class="chat-filter">
              <div class="filter">
                <h6
                  v-for="option in filterOptions"
                  :key="option.value"
                  class="cursor-pointer"
                  :class="{
                    active: option.value == query.status,
                  }"
                  @click="changeFilter(option.value)"
                >
                  {{ $t(option.text) }}
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div class="position-relative chat-chanel-wrapper">
          <div class="chat-user-list-wrapper list-group scroll-area overflow-y">
            <ul class="chat-users-list chat-list media-list">
              <queue-alert />
              <call-contact
                v-for="channel in channels"
                :key="channel.id"
                :channel="channel"
                tag="li"
                :is-active="activeChannel.id === channel.id"
                :class="{ active: activeChannel.id === channel.id }"
                @click="onChannelChange(channel)"
              />
            </ul>
            <div class="infinite-wrapper">
              <infinite-loading
                ref="infiniteLoading"
                :identifier="identifier"
                @infinite="listChannel"
              >
                <div slot="spinner" class="mt-2">
                  <b-spinner label="Spinning" />
                </div>
                <div slot="no-more" />
                <div slot="no-results" />
              </infinite-loading>
            </div>
          </div>
        </div>
        <div class="chat-fixed-bottom border">
          <div class="d-flex align-items-center w-100 justify-content-end">
            <div style="display: flex; align-items: center; position: relative">
              <!-- date filter -->
              <feather-icon
                icon="CalendarIcon"
                size="17"
                class="align-middle text-body"
                :class="{ 'text-primary': query.startDate || query.endDate }"
                style="cursor: pointer"
                @click="toggleDialog"
              />

              <!-- Fixed dialog -->
              <div
                v-if="dialogVisible"
                class="fixed-dialog"
                style="position: absolute; top: -285px; left: 0px"
              >
                <div>
                  <n-search-container
                    :show-header="false"
                    :fields="dateInputs"
                    :default-visible="true"
                    @search="search"
                    @reset="resetDate"
                  >
                    <n-search-input v-model="query" :fields="dateInputs" />
                  </n-search-container>
                </div>
              </div>
              <div style="margin-right: 1.2rem" class="d-flex flex-row" />

              <div
                v-if="query.searchType != 'm' || !query.search.trim()"
                class="d-flex flex-row"
              >
                <div class="dropdown chat-filter-dropdown my-1">
                  <b-dropdown variant="link" no-caret toggle-class="p-0" right>
                    <template #button-content>
                      <feather-icon
                        v-if="
                          query.type == 'assignToMe' ||
                          (query.type == 'allConversation' &&
                            query.operator == userData.id)
                        "
                        icon="UserIcon"
                        size="17"
                        class="align-middle text-body text-primary"
                      />
                      <feather-icon
                        v-else-if="
                          query.type == 'allConversation' && query.operator
                        "
                        icon="UserIcon"
                        size="17"
                        class="align-middle text-body"
                      />
                      <feather-icon
                        v-else-if="query.type == 'allConversation'"
                        icon="UsersIcon"
                        size="17"
                        class="align-middle text-body"
                      />
                      <feather-icon
                        v-else
                        icon="UserXIcon"
                        size="17"
                        class="align-middle text-body"
                      />
                    </template>

                    <b-dropdown-form v-show="query.type == 'allConversation'">
                      <b-form-group>
                        <label class="d-block">
                          {{ $t("field.operator") }}
                        </label>
                        <n-async-single-select
                          v-model="query.operator"
                          :init-options="query.operator"
                          repository="callOperator"
                          selection-key="id"
                          selection-label="name"
                          :clearable="true"
                          @input="onChangeOperator"
                        />
                      </b-form-group>
                    </b-dropdown-form>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BSpinner,
  BDropdown,
  BDropdownForm,
  BFormGroup,
  BFormSelect,
} from "bootstrap-vue";
import InfiniteLoading from "vue-infinite-loading";
import NAsyncSingleSelect from "@/components/NAsyncSingleSelect";
import { bus } from "@/libs/bus";
import useJwt from "@/auth/jwt/useJwt";
import QueueAlert from "@/components/QueueAlert.vue";
import NSearchContainer from "@/components/NSearchContainer";
import NSearchInput from "@/components/NSearchInput";

import store from "@/store";
import moment from "moment";
import DateInputs from "./searchDate.js";
import CallContact from "./CallContact.vue";

export default {
  components: {
    NSearchContainer,
    NSearchInput,
    // BSV
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BSpinner,
    BDropdown,
    BDropdownForm,
    BFormGroup,
    BFormSelect,
    QueueAlert,

    // 3rd party
    InfiniteLoading,

    // SFC
    NAsyncSingleSelect,

    CallContact,
  },
  props: {
    channels: {
      type: Array,
      default: () => [],
    },
    activeChannel: {
      type: Object,
      default: () => {},
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
    connectionStatus: {
      type: Boolean,
      default: true,
    },
    identifier: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      isShowSearch: !!this.$route.query.search,
      assignIcon: "UserIcon",
      filterOptions: [],
      query: {
        operator: this.$route.query.operator || null,
        type:
          this.$route.query.type ||
          store.state.app.callQuery.type ||
          "allConversation",
        status: this.$route.query.status || "",
        search: this.$route.query.search || "",
        searchType: this.$route.query.searchType || "m",
        startDate: this.$route.query.startDate
          ? moment(this.$route.query.startDate).startOf("day").toISOString()
          : null,
        endDate: this.$route.query.endDate
          ? moment(this.$route.query.endDate).endOf("day").toISOString()
          : null,
        cache: this.$route.query.cache,
        channel: this.$route.query.channel || null,
      },
      searchTypeOptions: [
        { value: "m", text: this.$t("general.message") },
        { value: "c", text: this.$t("general.channel") },
      ],
      dialogVisible: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },
  created() {
    const callQuery = {};
    if (this.query.cache != "no") {
      Object.keys(store.state.app.callQuery).forEach((key) => {
        if (!this.query[key]?.trim()) {
          callQuery[key] = store.state.app.callQuery[key];
        } else if (this.query[key] == "noCache") {
          callQuery[key] = "";
        }
      });
    }
    this.query = { ...this.query, ...callQuery };
    this.$nextTick(() => {
      this.mapFilterOption(this.query.type);
      this.changeFilter(this.query.status);

      bus.$on("notificationClick", (type) => {
        if (type == "chat") {
          this.mapFilterOption(this.query.type);
          this.changeFilter(this.query.status);
        }
      });
    });
  },
  beforeDestroy() {
    bus.$off("notificationClick");
  },
  methods: {
    reset() {
      this.$refs.search.reset();
      this.updateQuerySting();
    },
    resetDate() {
      this.query.startDate = "";
      this.query.endDate = "";
      this.updateQuerySting();
      this.toggleDialog();
      this.$emit("filter", this.query);
    },
    toggleDialog() {
      this.dialogVisible = !this.dialogVisible;
    },
    reloadData() {
      this.$emit("closeChannel", {});
      this.search();
    },
    listChannel($state = null) {
      this.$emit("load-channel", $state);
    },
    onChangeOperator() {
      this.query.search = "";
      this.query.status = "";
      this.updateQuerySting();
      this.$emit("filter", this.query);
    },
    onChangeSearchType() {
      this.updateQuerySting();
      this.$emit("filter", this.query);
    },
    onChannelChange(channel) {
      this.$emit("open-chat", channel);
    },
    changeFilter(filter) {
      let channel = null;
      if (this.$route.query.channel) {
        channel = this.$route.query.channel;
      }
      this.query.status = filter;
      this.updateQuerySting();
      if (channel) {
        this.query.channel = channel;
      }
      this.$emit("filter", this.query);
    },
    changeOperator(type) {
      this.query.search = "";
      this.query.status = "";
      this.query.operator = "";
      this.mapFilterOption(type);
      this.query.type = type;
      this.updateQuerySting();
      this.$emit("filter", this.query);
    },
    mapFilterOption(type) {
      if (type == "unassign") {
        this.filterOptions = [];
      } else {
        this.filterOptions = [
          {},
          {
            value: "",
            text: "chat.all",
          },
          {
            value: "started",
            text: "chat.started",
          },
          {
            value: "ended",
            text: "chat.ended",
          },
          {
            value: "missed",
            text: "chat.incoming",
          },
        ];
      }
    },
    searching() {
      this.isShowSearch = !this.isShowSearch;
      if (!this.isShowSearch && this.query.search) {
        this.query.search = "";
        this.search();
      }
    },
    search() {
      this.updateQuerySting();
      this.$emit("filter", this.query);
      this.dialogVisible = false;
    },
    updateQuerySting() {
      this.$router.replace({ query: this.query });
      this.$nextTick(() => {
        if (this.query.cache != "no") {
          store.commit("app/UPDATE_CALL_QUERY", {
            ...this.query,
            channel: undefined,
          });
        }
      });
    },
  },
  setup() {
    return {
      dateInputs: DateInputs,
      moment,
    };
  },
};
</script>

<style scoped>
.input-group-text {
  padding: 0 !important;
}

.custom-select:focus {
  box-shadow: none !important;
}

.fixed-dialog {
  position: fixed;
  height: 274px;
  top: 100px;
  left: 400px;
  width: 258px;
  z-index: 1000;
  background-color: #fff;
  border: 0px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
